{
  "name": "web-wel-admin",
  "version": "3.68.19",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration production",
    "connect-pr-to-prod-services": "deployment/scripts/deploy-review-app-with-prod-services.sh",
    "test": "ng test --watch=false",
    "lint": "ng lint",
    "lint-quiet": "ng lint --quiet",
    "lint-fix": "ng lint --fix",
    "postinstall": "node postinstall.js",
    "translate": "ngx-translate-extract --input ./src --output ./src/assets/i18n/es.json ./src/assets/i18n/en.json ./src/assets/i18n/ro.json --sort --format json; node translate-i18n.js ro es",
    "translate:clean": "rm ./src/assets/i18n/*.json; npm run translate",
    "prepare": "husky"
  },
  "private": true,
  "engines": {
    "node": "24.x",
    "npm": "11.x"
  },
  "dependencies": {
    "@angular/animations": "22.1.4",
    "@angular/cdk": "22.1.4",
    "@angular/common": "22.1.4",
    "@angular/compiler": "22.1.4",
    "@angular/core": "22.1.4",
    "@angular/forms": "22.1.4",
    "@angular/material": "22.1.4",
    "@angular/platform-browser": "22.1.4",
    "@angular/router": "22.1.4",
    "@colsen1991/ngx-translate-extract-marker": "3.0.1",
    "@kokotree-inc/angular-code-input": "1.6.3",
    "@kolkov/angular-editor": "3.1.0",
    "@ngrx/effects": "22.0.0",
    "@ngrx/store": "22.0.0",
    "@ngrx/store-devtools": "22.0.0",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@sentry/angular": "10.72.0",
    "@snowplow/browser-plugin-button-click-tracking": "4.10.1",
    "@snowplow/browser-plugin-form-tracking": "4.10.1",
    "@snowplow/browser-plugin-link-click-tracking": "4.10.1",
    "@snowplow/browser-tracker": "4.10.1",
    "@wam/components": "0.5.6",
    "@wap/batch": "0.0.86",
    "@wap/catalog-v5": "5.15.1",
    "@wap/configuration": "4.1.1",
    "@wap/curriculum-visibility": "0.1.1",
    "@wap/licensing": "3.2.202",
    "@wap/profile-picture": "1.1.39",
    "@wap/reporting": "3.0.16",
    "@wap/session": "0.0.46",
    "@wap/tenant": "2.2.75",
    "@wap/user-lookup": "2.0.81",
    "@wap/wel-event-bridge-interface": "2.1.0",
    "baseline-browser-mapping": "2.11.20",
    "d3": "7.9.0",
    "date-fns": "4.4.0",
    "deep-object-diff": "1.1.9",
    "file-saver": "2.0.5",
    "jsonapi-serializer": "3.6.9",
    "jspdf": "4.2.1",
    "lodash-es": "4.18.1",
    "ngx-infinite-scroll": "22.0.0",
    "ngx-progressbar": "14.0.0",
    "pdf-lib": "1.17.1",
    "qrcode": "1.5.4",
    "rxjs": "7.8.2",
    "sugar": "2.0.6",
    "tslib": "2.8.1",
    "usa-states": "0.0.6",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular/build": "22.1.6",
    "@angular/cli": "22.1.6",
    "@angular/compiler-cli": "22.1.4",
    "@faker-js/faker": "10.6.0",
    "@google-cloud/translate": "10.0.1",
    "@types/d3": "7.4.3",
    "@types/jsonapi-serializer": "3.6.8",
    "@types/lodash-es": "4.17.12",
    "@types/node": "24.4.0",
    "@types/qrcode": "1.5.6",
    "@vendure/ngx-translate-extract": "10.2.0",
    "@vitest/coverage-v8": "4.1.11",
    "angular-eslint": "22.2.0",
    "dotenv": "17.4.2",
    "eslint": "10.9.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-prettier": "5.5.6",
    "eslint-plugin-unused-imports": "4.4.1",
    "husky": "9.1.7",
    "jest-marbles": "4.0.1",
    "jsdom": "30.0.1",
    "lint-staged": "17.4.1",
    "ng-lint-staged": "12.0.4",
    "prettier": "3.9.6",
    "timezone-mock": "1.4.3",
    "ts-mockito": "2.6.1",
    "typescript": "6.0.3",
    "typescript-eslint": "8.68.0",
    "vitest": "4.1.11",
    "vitest-sonar-reporter": "3.0.0"
  },
  "lint-staged": {
    "src/**/*.{ts,html}": [
      "ng-lint-staged lint --fix --"
    ]
  }
}
